// config.js

export const config = {
    basic_auth: {
        user: 'z',
        pass: 'fHFKaPhXs2Zg'
    },
    // api: 'https://physics.purdue.edu/app/vitrodb/pbstracker/api/'
    api: 'https://pbstracker-437ab.web.app/api/'
    // api : 'http://localhost:3001/api/'
}

